module.exports = "/_next/static/images/strategic-planning-training-service-3-e60c5dc9fd6340523621f02cc2600c15.webp";